import { render, staticRenderFns } from "./SignatureDimension.vue?vue&type=template&id=a92020d6&scoped=true&"
import script from "./SignatureDimension.vue?vue&type=script&lang=js&"
export * from "./SignatureDimension.vue?vue&type=script&lang=js&"
import style0 from "./SignatureDimension.vue?vue&type=style&index=0&id=a92020d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92020d6",
  null
  
)

export default component.exports